import { LabourForecastPermissions } from './labourForecast.permissions';
import { LabourForecastRoles } from './labourForecast.roles';

export const labourForecastMappings = {
  [LabourForecastPermissions.GET_LABOUR_FORECAST]: [
    LabourForecastRoles.LABOUR_FORECAST_MANAGER,
  ],
  [LabourForecastPermissions.CREATE_LABOUR_FORECAST]: [
    LabourForecastRoles.LABOUR_FORECAST_MANAGER,
  ],
  [LabourForecastPermissions.UPDATE_LABOUR_FORECAST]: [
    LabourForecastRoles.LABOUR_FORECAST_MANAGER,
  ],
  [LabourForecastPermissions.DELETE_LABOUR_FORECAST]: [
    LabourForecastRoles.LABOUR_FORECAST_MANAGER,
  ],
};
